import * as React from 'react';

export const GalleryVideoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    {/* tslint:disable-next-line:max-line-length */}
    <path
      fill="#2B87DB"
      fillRule="nonzero"
      d="M15 0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-4.4 8.8l-4 3c-.6.5-1.6 0-1.6-.8V5a1 1 0 0 1 1.6-.8l4 3c.5.4.5 1.2 0 1.6z"
    />
  </svg>
);
